export type MailItem = {
  id: 'do_not_mail' | 'mail_and_view' | 'mail_only'
  title: string
}

export const mailItems: Array<MailItem> = [
  {
    id: 'do_not_mail',
    title: 'Не отправлять',
  },
  {
    id: 'mail_and_view',
    title: 'Отправить файл на e-mail по завершении формирования',
  },
  {
    id: 'mail_only',
    title: 'Отправить файл на e-mail без формирования отчета на экране',
  },
]
